import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Badge,
  Box,
  IconButton,
  Spinner,
  Tooltip,
} from "@chakra-ui/react";
import { FaRobot } from "react-icons/fa";

import autopilotApi from "../../../_API/autopilotApi";
import WamAutopilotReviewDrawer from "./WamAutopilotReviewDrawer";
import { getAutopilotPendingCount } from "./autopilotModuleMeta";


const WamAutopilotNotificationBadge = () => {
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  const loadOverview = useCallback(async () => {
    try {
      const response = await autopilotApi.overview();
      setOverview(response.data || {});
    } catch (_error) {
      setOverview(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadOverview();
  }, [loadOverview]);

  const pendingCount = useMemo(() => getAutopilotPendingCount(overview), [overview]);

  return (
    <>
      <Box position="relative">
        <Tooltip hasArrow label="Autopilot pendiente">
          <IconButton
            aria-label="Autopilot pendiente"
            icon={loading ? <Spinner size="sm" /> : <FaRobot />}
            variant="ghost"
            borderRadius="full"
            onClick={() => {
              setIsOpen(true);
              loadOverview();
            }}
          />
        </Tooltip>
        {pendingCount > 0 ? (
          <Badge
            colorScheme="purple"
            borderRadius="full"
            position="absolute"
            top="-2px"
            right="-2px"
            px={1}
            fontSize="0.6rem"
            data-testid="autopilot-notification-count"
          >
            {pendingCount > 99 ? "99+" : pendingCount}
          </Badge>
        ) : null}
      </Box>

      <WamAutopilotReviewDrawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        overview={overview}
        loading={loading}
      />
    </>
  );
};


export default WamAutopilotNotificationBadge;
